var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from 'helpers/Api';
export default class StructureStore {
    constructor() {
        this.getStructure = (store) => {
            return api.get('structure')
                .then((structure) => {
                // console.log('structure: ', structure)
                return this.setData(structure, store);
            });
        };
    }
    setData(structure, store) {
        return __awaiter(this, void 0, void 0, function* () {
            const stretches = [];
            structure.operationLines.forEach(operationLine => stretches.push(...operationLine.stretches));
            const packets = [];
            structure.operationLines.forEach(operationLine => packets.push(...operationLine.packets));
            // await store.moneysStore.setData(structure.moneys)
            // await store.afiliatesStore.setData(structure.afiliatesOptions)
            // await store.collaboratorStretchesStore.setData(structure.collaboratorStretches)
            // await store.discountReasonStore.setData(structure.discountReasons)
            // await store.movementProviderStore.setData(structure.movementProviders)
            store.stretchesStore.setData(stretches);
            store.collaboratorStretchesStore.setData(structure.collaboratorStretches);
            store.packetsStore.setData(packets);
            store.operationLines.setData(structure.operationLines);
            // await store.receiptLayoutStore.setData(structure.receiptLayouts)
            // await store.settingCashMovementStore.setData(structure.settingCashMovements)
            // await store.usedGaugesStore.setData(structure.usedGauges)
            return structure;
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Structures/StructuresStore.ts
// module id = 566
// module chunks = 0